import { ErrorIcon } from 'assets/svgs';
import React, { useState, forwardRef } from 'react';
import styles from './text-area.module.scss';

const TextArea = forwardRef((props, ref) => {
  const [count, setCount] = useState(0);

  return (
    <div className={styles.textArea}>
      <label>{props.label}</label>
      <textarea
        {...props}
        onChange={props.onChange}
        onInput={(e) => setCount(e.target.value.length)}
        ref={ref}
        data-testid={props.testId}
        id={props.name}
        name={props.name}
        
      />
      <p className={styles.count}>
        {' '}
        {count}/{props.maxLength}
      </p>
      {props.error && (
        <p className={styles.authFormGroupError}>
          <ErrorIcon />
          {props.error}
        </p>
      )}
    </div>
  );
});

export default TextArea;
